'use client';

import { c as _c } from "react/compiler-runtime";
import useCardWatch from '@shared/utils/hooks/useCardWatch';
import { Eye, EyeOff } from 'lucide-react';
import { client } from '../../utils/trpc';
type Props = {
  /** The card's uuid. */
  postId: string;
};

// Watch / Watching on an open board card (.specs/notifications.md → Card
// watch). The author starts out watching; one tap turns it off, and it stays
// off until tapped again.
const CardWatchButton = t0 => {
  const $ = _c(14);
  const {
    postId
  } = t0;
  const {
    watching,
    setWatching
  } = useCardWatch(client, postId);
  if (watching === undefined) {
    return null;
  }
  const Icon = watching ? Eye : EyeOff;
  const t1 = watching ? "Stop watching this card" : "Watch this card";
  let t2;
  if ($[0] !== setWatching || $[1] !== watching) {
    t2 = e => {
      e.stopPropagation();
      setWatching(!watching);
    };
    $[0] = setWatching;
    $[1] = watching;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const t3 = `flex items-center gap-1 rounded-full px-2 py-0.5 text-xs font-emphasis transition-colors duration-200 hover:bg-background-light ${watching ? "text-primary" : "text-textSecondary"}`;
  let t4;
  if ($[3] !== Icon) {
    t4 = <Icon size={14} />;
    $[3] = Icon;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const t5 = watching ? "Watching" : "Watch";
  let t6;
  if ($[5] !== t5) {
    t6 = <span>{t5}</span>;
    $[5] = t5;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== t1 || $[8] !== t2 || $[9] !== t3 || $[10] !== t4 || $[11] !== t6 || $[12] !== watching) {
    t7 = <button type="button" data-id="card-watch-toggle" title={t1} aria-pressed={watching} onClick={t2} onMouseDown={_temp} className={t3}>{t4}{t6}</button>;
    $[7] = t1;
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
    $[11] = t6;
    $[12] = watching;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  return t7;
};
export default CardWatchButton;
function _temp(e_0) {
  return e_0.stopPropagation();
}